








import MobileChecker from '@/components/MobileChecker.vue';
import { Component, Vue } from 'vue-property-decorator';
import AllModals from './components/modals/AllModals.vue';

@Component({
  components: {
    AllModals,
    MobileChecker,
  },
})
export default class App extends Vue {}
